import { Injectable, inject } from '@angular/core';
import { Auth, AuthCredential, authState, deleteUser, signInAnonymously, signInWithCredential, signOut } from '@angular/fire/auth';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  protected auth: Auth = inject(Auth);
  private authState$ = authState(this.auth);
  private static isInit = false;
  public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  constructor() { }

  get currentUser() {
    return this.auth.currentUser;
  }

  async getAuthorization() {
    const idToken = await this.currentUser.getIdToken();
    return { Authorization: 'Bearer ' + idToken };
  }

  authStateChange() {
    if(AuthService.isInit) return;
    AuthService.isInit = true;
    
    this.authState$.subscribe((user: any) => {
      this.isAuthenticated.next(user != null);
    });
  }

  signInAnonymously() {
    return signInAnonymously(this.auth);
  }

  signInWithCredential(credential: AuthCredential) {
    return signInWithCredential(this.auth, credential);
  }

  deleteUser() {
    return deleteUser(this.currentUser);
  }

  signOut() {
    return Promise.all([
      FirebaseAuthentication.signOut(),
      signOut(this.auth)
    ]);
  }

}
